import type { LocalizedName, Money } from "@glowin/schemas";

/** Format money from minor units. Never does float math on the stored value. */
export function formatMoney(money: Money): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: money.currency
  }).format(money.amountMinor / 100);
}

/** Signed delta for modifier options: "+$2.00", "included", "-$1.00". */
export function formatDelta(money: Money): string {
  if (money.amountMinor === 0) return "included";
  const sign = money.amountMinor > 0 ? "+" : "-";
  return `${sign}${formatMoney({ ...money, amountMinor: Math.abs(money.amountMinor) })}`;
}

/** Show both scripts when present; the console is used by bilingual staff. */
export function displayName(name: LocalizedName): string {
  return name.zh ? `${name.en} · ${name.zh}` : name.en;
}

/** Parse a user-typed price ("13.95", "$13.95") into minor units. */
export function parsePriceToMinor(input: string): number | undefined {
  const cleaned = input.replace(/[$,\s]/g, "");
  if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) return undefined;
  return Math.round(Number(cleaned) * 100);
}
